<template>
    <div>
        <loading 
            :active.sync="isLoading" 
            :opacity="0.8"
            color="#f5365c"
            :is-full-page="true">
        </loading>
        <base-header type="gradient-warning" class="pb-6 pb-8 pt-5 pt-md-8">
            <router-link to="/estaciones"
                            class="h4 mb-0 text-white text-uppercase d-none d-lg-inline-block">
                <i class="ni ni-bold-left pr-3"></i>Regresar
            </router-link>
            <!-- Card stats -->
            <div class="row pt-4">
                <div class="col-xl-6 col-lg-6 col-md-6">
                    <stats-card title="Agregado el"
                        type="gradient-red"
                        :sub-title="getReadableDate(stationData.createdOn)"
                        :location="stationData.createdBy ? `por ${stationData.createdBy}` : '' "
                        icon="ni ni-calendar-grid-58"
                        class="mb-4 mb-xl-0">
                    </stats-card>
                </div>
                <div v-if="stationData.updatedOn" class="col-xl-6 col-lg-6 col-md-6">
                    <stats-card title="Actualizado"
                        type="gradient-red"
                        :sub-title="stationData.updatedOn ? getFromNowDate(stationData.updatedOn) : ''"
                        :location="stationData.updatedBy ? `por ${stationData.updatedBy}` : '' "
                        icon="ni ni-calendar-grid-58"
                        class="mb-4 mb-xl-0">
                    </stats-card>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col-xl-4 order-xl-2 mb-5 mb-xl-0">
                    <div class="card card-profile shadow">
                        <div class="card-body pt-0 pt-sm-4">
                            <div class="text-center">
                                <h3>
                                    {{stationData.razonSocial}}
                                </h3>
                            </div>
                            <hr class="my-4" />
                            <div class="row">
                                <div class="col">
                                    <div class="card-profile-stats d-flex justify-content-center">
                                        <div>
                                            <span class="heading">{{clientData.clientId}}</span>
                                            <span class="description">ID de Cliente</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr class="my-4" />
                            <small>{{clientData.createdOn ? `Agregado el ${getReadableDate(clientData.createdOn)} por ${clientData.createdBy}` : ''}}</small>
                        </div>
                    </div>
                    <div v-if="stationData.archivos.length > 0" class="card card-profile shadow mt-4">
                        <div class="card-body pt-0 pt-sm-4">
                            <div class="text-center">
                                <h6 class="heading-small text-muted mb-4">Archivos</h6>
                            </div>
                            <hr class="my-4" />
                            <div class="row">
                                <div class="col">
                                    <div>
                                        <i class="ni ni-cloud-download-95 pr-3"></i>                   
                                        <span>Representante Legal</span>
                                    </div>
                                    <div>
                                        <i class="ni ni-cloud-download-95 pr-3"></i>                   
                                        <span>Representante SASISOPA</span>
                                    </div>
                                    <div>
                                        <i class="ni ni-cloud-download-95 pr-3"></i>                   
                                        <span>Testigo</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="editMode" class="col-xl-8 order-xl-1">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-6">
                                    <h3 class="mb-0">{{stationData.numCRE}}</h3>
                                    <h5 class="mb-0 text-muted">{{stationData.estacionId}}</h5>
                                </div>
                                <div class="col-6 text-right">
                                    <a href="#!" class="btn btn-sm btn-warning" style="" @click="cancelSave">Descartar cambios</a>
                                    <a href="#!" class="btn btn-sm btn-success" @click="onSave">Guardar</a>
                                </div>
                            </div>
                        </div>
                        <template>
                            <form @submit.prevent>
                                <h6 class="heading-small text-muted mb-4">Datos de contacto</h6>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Contacto"
                                                        placeholder="Contacto"
                                                        input-classes="form-control-alternative"
                                                        v-model="stationData.contacto"
                                            />
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Tipo contacto"
                                                        placeholder="Tipo contacto"
                                                        input-classes="form-control-alternative"
                                                        v-model="stationData.tipoContacto"
                                            />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Teléfono"
                                                        placeholder="Teléfono"
                                                        input-classes="form-control-alternative"
                                                        v-model="stationData.telefono"
                                            />
                                        </div>
                                        <div class="col-lg-6">
                                            <base-input alternative=""
                                                        label="Teléfono 2"
                                                        placeholder="Teléfono 2"
                                                        input-classes="form-control-alternative"
                                                        v-model="stationData.movil"
                                            />
                                        </div>
                                        <div class="col-lg-12">
                                            <base-input alternative=""
                                                        label="Correo Electrónico"
                                                        placeholder="Correo Electrónico"
                                                        input-classes="form-control-alternative"
                                                        v-model="stationData.email"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4" />
                                <!-- Address -->
                                <h6 class="heading-small text-muted mb-4">Ubicación</h6>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <base-input alternative=""
                                                        label="Dirección"
                                                        placeholder="Dirección"
                                                        input-classes="form-control-alternative"
                                                        v-model="stationData.domicilio"
                                            />
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-4">
                                            <base-input alternative=""
                                                        label="Ciudad"
                                                        placeholder="Ciudad"
                                                        input-classes="form-control-alternative"
                                                        v-model="stationData.ciudad"
                                            />
                                        </div>
                                        <div class="col-lg-4">
                                            <base-input alternative=""
                                                        label="Estado"
                                                        placeholder="Estado"
                                                        input-classes="form-control-alternative"
                                                        v-model="stationData.estado"
                                            />
                                        </div>
                                        <div class="col-lg-4">
                                            <base-input alternative=""
                                                        label="Código Postal"
                                                        placeholder="Código Postal"
                                                        input-classes="form-control-alternative"
                                                        v-model="stationData.cp"
                                            />
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4" />
                                <!-- Description -->
                                <h6 class="heading-small text-muted mb-4">Notas</h6>
                                <div class="pl-lg-4">
                                    <div class="form-group">
                                        <base-input alternative="">
                                            <textarea rows="10" v-model="stationData.notas" class="form-control form-control-alternative" placeholder="Notas y comentarios acerca del cliente"></textarea>
                                        </base-input>
                                    </div>
                                </div>
                            </form>
                        </template>
                    </card>
                </div>
                <div v-else class="col-xl-8 order-xl-1">
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">
                                <div class="col-8">
                                    <h3 class="mb-0">{{stationData.numCRE}}</h3>
                                    <h5 class="mb-0 text-muted">{{stationData.estacionId}}</h5>
                                </div>
                                <div class="col-4 text-right">
                                    <a href="#!" class="btn btn-sm btn-primary" @click="toggleEditMode">Editar</a>
                                </div>
                            </div>
                        </div>
                        <template>
                            <form @submit.prevent>
                                <h6 class="heading-small text-muted mb-4">Datos de contacto</h6>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <label class="form-control-label">
                                                Contacto
                                            </label>
                                            <p class="text-left">
                                                {{stationData.contacto ? stationData.contacto : '-'}}
                                            </p>
                                        </div>
                                        <div class="col-lg-6">
                                            <label class="form-control-label">
                                                Tipo de contacto
                                            </label>
                                            <p class="text-left">
                                                {{stationData.tipoContacto ? stationData.tipoContacto : '-'}}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-6">
                                            <label class="form-control-label">
                                                Teléfono 1
                                            </label>
                                            <p class="text-left">
                                                {{stationData.telefono ? stationData.telefono : '-'}}
                                            </p>
                                        </div>
                                        <div class="col-lg-6">
                                            <label class="form-control-label">
                                                Teléfono 2
                                            </label>
                                            <p class="text-left">
                                                {{stationData.movil ? stationData.movil : '-'}}
                                            </p>
                                        </div>
                                        <div class="col-lg-12">
                                            <label class="form-control-label">
                                                Correo Electrónico
                                            </label>
                                            <p class="text-left">
                                                {{stationData.email ? stationData.email : '-'}}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4" />
                                <!-- Address -->
                                <h6 class="heading-small text-muted mb-4">domicilio</h6>
                                <div class="pl-lg-4">
                                    <div class="row">
                                        <div class="col-md-12">
                                            <label class="form-control-label">
                                                Domicilio
                                            </label>
                                            <p class="text-left">
                                                {{stationData.domicilio ? stationData.domicilio : '-'}}
                                            </p>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-lg-4">
                                            <label class="form-control-label">
                                                Ciudad
                                            </label>
                                            <p class="text-left">
                                                {{stationData.ciudad ? stationData.ciudad : '-'}}
                                            </p>
                                        </div>
                                        <div class="col-lg-4">
                                            <label class="form-control-label">
                                                Estado
                                            </label>
                                            <p class="text-left">
                                                {{stationData.estado ? stationData.estado : '-'}}
                                            </p>
                                        </div>
                                        <div class="col-lg-4">
                                            <label class="form-control-label">
                                                Código Postal
                                            </label>
                                            <p class="text-left">
                                                {{stationData.cp ? stationData.cp : '-'}}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                                <hr class="my-4" />
                                <!-- Description -->
                                <h6 class="heading-small text-muted mb-4">Notas</h6>
                                <div class="pl-lg-4">
                                    <div class="form-group">
                                        <base-input alternative="">
                                            <textarea readonly v-model="stationData.notas" rows="10" class="form-control form-control-alternative" placeholder="Notas y comentarios acerca del cliente"></textarea>
                                        </base-input>
                                    </div>
                                </div>
                            </form>
                        </template>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';
    import moment from "moment";
    export default {
        name: 'user-profile',
        components: {
            Loading
        },
        created(){
            const token = localStorage.getItem('id_token');
            this.isLoading = true;
            let {clientId, estacionId} = this.$route.params;
            fetch(`${process.env.VUE_APP_VREMEC_API}/api/clients/${clientId}/stations/${estacionId}`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then(response => response.json())
                .then((data) => {
                    this.stationData = data.Data.Details.Item;
                    this.originalStationData = data.Data.Details.Item;
                    this.clientData = data.Data.Client.Item;
                    this.stationData.archivos = []
                    this.isLoading = false;
                });
        },
        methods: {
            toggleEditMode: function () {
                this.editMode = !this.editMode;
            },
            getReadableDate(timestamp){
                moment.locale('es');
                let time = moment(timestamp, 'x');
                return time.format('LL');
            },
            getFromNowDate(timestamp){
                moment.locale('es');
                let time = moment(timestamp, 'x').from();
                return time;
            },
            returnToTable(){
                let loader = this.$loading.show({
                  // Optional parameters
                  container: this.fullPage ? null : this.$refs.formContainer,
                  canCancel: true,
                  onCancel: this.onCancel,
                });
                // simulate AJAX
                setTimeout(() => {
                  loader.hide()
                },5000)  
            },
            doAjax() {
                this.isLoading = true;
                // simulate AJAX
                setTimeout(() => {
                  this.isLoading = false
                },5000)
            },
            cancelSave(){
                this.editMode = false;
                this.stationData = {...this.originalStationData};
            },
            onSave(){
                const token = localStorage.getItem('id_token');
                let {clientId, estacionId} = this.$route.params;
                this.isLoading = true;
                fetch(`${process.env.VUE_APP_VREMEC_API}/api/clients/${clientId}/stations/${estacionId}`, {
                    method: 'POST', 
                    body: JSON.stringify(this.stationData),
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                }).then(response => response.json())
                .then((data) => {
                    this.stationData.updatedOn = data.Data.updatedOn;
                    this.stationData.updatedBy = data.Data.updatedBy;
                    this.isLoading = false;
                    this.editMode = false;
                    this.originalStationData = {...this.stationData};
                });
            }
        },
        data() {
            return {

                editMode: false,
                isLoading: false,
                originalStationData: {},
                stationData: {
                    ciudad: undefined,
                    clientId: undefined,
                    contacto: undefined,
                    cp: undefined,
                    createdBy: undefined,
                    createdOn:undefined,
                    email: undefined,
                    estacionId: undefined,
                    estado: undefined,
                    movil: undefined,
                    numCRE: undefined,
                    razonSocial: undefined,
                    telefono:undefined,
                    tipoContacto: undefined,
                    notas: undefined,
                    updatedOn: undefined,
                    updatedBy: undefined,
                    archivos: []
                },
                clientData: {}
            }
        },
    };
</script>
<style></style>
